import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import {Tooltip } from '@mui/material';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { EncourIcon, ExpireIcon, RejetIcon, ValiderIcon } from '../../../data/SVGs';

function StatutDocument({statut,motifRejet}) {
    StatutDocument.propTypes = {
        statut: PropTypes.any,
        motifRejet:PropTypes.any
    };
    const { i18n } = useTranslation();
    return (
        <>
            {statut == 'rejete' && (
                <div style={{display:'flex',flexDirection:'row',alignItems: 'center'}}>
                    <div
                        className="frame20Kbis"
                    >
                        <div className="frame21Kbis">
                            <RejetIcon />
                        </div>
                        <p className="frame22Kbis">{i18n.t('Rejeté')}</p>
                    </div>
                    <Tooltip title={motifRejet}>
                        <InfoOutlinedIcon/>
                    </Tooltip>
                </div>
            )}

            {(statut=='valide'||statut=='signe') &&
                <div className='frame23Kbis'>
                    <div className='frame21Kbis'>
                        <ValiderIcon/>
                    </div>
                    <p className='frame24Kbis'>
                        {i18n.t('Validé')}
                    </p>
                </div>
            }

            {(statut=='encours'||statut=='aValider') &&
            <div className='frame25Kbis'>
                <div className='frame21Kbis'>
                    <EncourIcon />
                </div>
                <p className='frame26Kbis'>
                    {i18n.t('En cours')}
                </p>
            </div>
            }

            {statut=='expire' &&
                <div className='frame27Kbis'>
                    <div className='frame21Kbis'>
                        <ExpireIcon />
                    </div>
                    <p className='frame28Kbis'>
                        {i18n.t('Expiré')}
                    </p>
                </div>
            }
        </>
    );
}
export default StatutDocument;